import { render, staticRenderFns } from "./QueueList.vue?vue&type=template&id=d7970b32&scoped=true"
import script from "./QueueList.vue?vue&type=script&lang=js"
export * from "./QueueList.vue?vue&type=script&lang=js"
import style0 from "./QueueList.vue?vue&type=style&index=0&id=d7970b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7970b32",
  null
  
)

export default component.exports